import { Box, Typography } from '@mui/material';
import * as React from 'react';

type StepProps = {
  title: string;
  subtitle: string;
  sx?: any;
  position: string;
  isActive: boolean;
}

const Step: React.FC<StepProps> = ({ title, subtitle, sx, position, isActive }) => {

  const positions = {
    'last': 'polygon(75% 0%, 75% 54%, 75% 100%, 0% 100%, 12% 51%, 0% 0%)',
    'first': 'polygon(75% 0%, 86% 51%, 75% 100%, 0% 100%, 0 51%, 0% 0%)',
    'other': 'polygon(75% 0%, 85% 50%, 75% 100%, 0% 100%, 11% 49%, 0% 0%)',
  };

  const bgColor = isActive ? '#ceface' : '#F7F7F7';
  const borderColor = isActive ? '#15ab51' : 'rgba(128,128,128,0.8)';
  const color = isActive ? '#066347' : '#000';

  return (
    <Box
      sx={{
        position: 'relative',
        width: '200px',
        height: '57.74px',
        clipPath: positions[position],
        backgroundColor: bgColor,
        border: '1px solid transparent',
        ...sx,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '-2px',
          left: '-16px',
          right: '-24px',
          bottom: '-1px',
          clipPath: positions[position],
          border: `135px solid ${borderColor}`,
        }}
      />
      <Box
        sx={{
          width: '100%',
          height: '100%',
          clipPath: positions[position],
          backgroundColor: bgColor,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '0 0 0 50px',
          boxSizing: 'border-box',
        }}
      >
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: '500',
            color: color,

            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            width: '100px',
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: '12px',
            fontWeight: '500',
            color: '#066347',
          }}
        >
          {subtitle}
        </Typography>
      </Box>
    </Box>
  );
};

export default Step;